import {RefObject, useEffect} from "react"

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(refs: RefObject<HTMLElement>[], callback: Function, childRef: RefObject<HTMLElement>) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element or child element
         */
        function handleClickOutside(event: MouseEvent) {

            let shouldntClose = true

            for (const ref of refs) {
                if (ref.current && !ref.current.contains(event.target as Node) &&
                    (!childRef || (childRef && !childRef.current?.contains(event.target as Node)))) {
                    shouldntClose = false
                }
            }

            if (!shouldntClose) {
                callback()
            }

        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [refs]);
}